<template>
  <div class="dashboard">
    <h1>EMaC Administration Dashboard: {{ user.email }}</h1>
    <button type="submit" class="btn btn-primary btn-success" @click="linkeToAdd">Add</button>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Names</th>
          <th scope="col">Edit</th>
          <th scope="col">Delete</th>
        </tr>
      </thead>
      <tbody>
      <tr scope="row" v-for="item in configurations">
        <td>{{ item.name }}</td>
        <td>
          <router-link :to="{ name: 'ConfigurationEdit', params: { configurationHash: item.configuration_hash }}">Edit</router-link>
        </td>
        <td>
          <button type="submit" class="btn btn-primary btn-danger" @click="confirmDelete(item.configuration_hash)">Delete</button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'Dashboard',
    computed: mapGetters(['user', 'isAuthenticated', 'configurations']),
    mounted() {
      // eslint-disable-next-line
      this.$store.dispatch('listConfigurations');
    },
    methods: {
      ...mapActions(['deleteConfiguration']),
      linkeToAdd() {
        this.$store.commit('RESET_CONFIGURATION');
        this.$router.push({ name: 'ConfigurationAdd' });
      },
      confirmDelete(configurationHash) {
        if (window.confirm('Are you sure you want to delete this configuration?')) {
          this.deleteConfiguration(configurationHash);
        }
      }
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue